import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../helper'
const state = {
};
const getters = {
};
const mutations = {
};

const actions = {
    addPacksInCart: (context,data) => {
        console.log("before call api",data)
        return new Promise( (resolve, reject) => {
            fetch(context.getters.baseUrl + '/subscriber/v1/cart', {
              method: 'POST',
              body: data
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json() 
            }).then((data) => {
                resolve(data)
             }).catch((error) => {
                reject(error)
             });
        });
    },
    removePackFromCart: (context,data) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(data)
        return new Promise( (resolve, reject) => {
            fetch(context.getters.baseUrl + '/subscriber/v1/cart/remove' + queryStr, {
                method: 'GET'
            })
            .then(errorServeiceHandler)
            .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            });
        });
    },
    getCartData: (context) => {
      return new Promise( (resolve, reject) => {
        fetch(context.getters.baseUrl + '/subscriber/v1/cart', {
          method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
                return response.json()
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
              reject(error)
            });
        });
    },
    getPaymentStatus: (context, dataObj) => {
        return new Promise((resolve, reject) => {
            let queryStr = makeQueryStringDync(dataObj)
            console.log(queryStr)
            fetch(context.getters.baseUrl + '/subscriber/paymentstatuscheck' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    resolve({"status":true,"msg":{"name_on_card":"NA","bank_ref_num":"959405","udf3":"","hash":"853e78415d6423db5af35d81f36f3a2621cf20fe32d3714351bd001e828c840a4c4aa89169673b45ccd2c6b906e3df0fdae109a716a750a5832f0815315adbce","firstname":"indigitial","net_amount_debit":"10.0","payment_source":"Easebuzz","surl":"https:\/\/imclselfcaretest.mobiotics.com\/subscriber\/paymentconfirm","error_Message":"PGS10001-Success","issuing_bank":"NA","cardCategory":"NA","phone":"9999999999","easepayid":"TBCPTAVIQT","cardnum":"NA","key":"2PBP7IABZ2","udf8":"","unmappedstatus":"NA","PG_TYPE":"NA","addedon":"2022-12-27 11:14:21","cash_back_percentage":"50.0","status":"success","card_type":"Debit Card","merchant_logo":"NA","udf6":"","udf10":"","txnid":"7151948DP","productinfo":"NXT SELFCARE RECHARGE","furl":"https:\/\/imclselfcaretest.mobiotics.com\/subscriber\/paymentconfirm","udf1":"12350940","amount":"10.0","udf2":"","udf5":"","mode":"DC","udf7":"","error":"PGS10001-Success","udf9":"","bankcode":"NA","deduction_percentage":"2.3","email":"test@test.com","udf4":""}})
                    reject(error);
                });
        });
    }
};
export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js